import { createFileRoute } from '@tanstack/react-router';

import { MissionRecapPage } from '@/features/missionRecap/MissionRecapPage';

export const Route = createFileRoute('/missions/$missionId')({
	component: MissionRoute,
	staticData: { showDetailedHeader: true },
});

function MissionRoute() {
	const { missionId } = Route.useParams();
	return <MissionRecapPage missionId={missionId} />;
}
